import React, { FC } from 'react'

import { Switch, Route } from 'react-router-dom'
import Privacy from './Privacy'
import getDefaultTheme from '../config/getDefaultTheme'
import { CssBaseline, ThemeProvider, Theme } from '@mui/material'
import { ExternalLinksConfiguration } from '@professocial/professocialTypes/types'

type IProps = {
  externalLinksConfiguration?: ExternalLinksConfiguration
  user?: any
}

export interface ITemplateProps {
  topInformation?: string
  title: string
  text: string
}

const ProfessocialExternalLinks: FC<IProps> = (props) => {
  const theme: Theme = props.externalLinksConfiguration?.theme || getDefaultTheme()
  const privacy: ITemplateProps = props.externalLinksConfiguration?.data.privacy
  const termsOfUse: ITemplateProps = props.externalLinksConfiguration?.data.termsOfUse

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Switch>
        <Route path={`${props.user ? '/' + props.user.role.toLowerCase() : ''}/privacy`} component={() => <Privacy title={privacy.title} text={privacy.text} />} />
        <Route path={`${props.user ? '/' + props.user.role.toLowerCase() : ''}/termsOfUse`} component={() => <Privacy topInformation={termsOfUse.topInformation} title={termsOfUse.title} text={termsOfUse.text} />} />
      </Switch>
    </ThemeProvider>
  )
}

export default ProfessocialExternalLinks
